module.exports = __webpack_public_path__ + "static/vertical.3898c8ce7273c65889b3f5c64a4ed4a2.svg";